import { render, staticRenderFns } from "./labpage.vue?vue&type=template&id=e6808ff4&"
import script from "./labpage.vue?vue&type=script&lang=js&"
export * from "./labpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports